import script from "./LocationRepository.vue?vue&type=script&lang=js"
export * from "./LocationRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__